// Formatea un valor numérico con comas de miles para mostrarlo en un input tipo texto
// (los inputs type="number" nativos no permiten comas). Solo visual — quitar las comas
// antes de enviar al backend con LimpiarNumero.
export const FormatNumeroInput = (valor) => {
  if (valor === "" || valor === null || valor === undefined) return "";
  const limpio = String(valor).replace(/,/g, "");
  if (limpio === "" || limpio === "-") return limpio;

  const [entero, decimal] = limpio.split(".");
  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimal !== undefined ? `${enteroFormateado}.${decimal}` : enteroFormateado;
};

// Quita las comas de miles y deja el valor listo para Number()/envío al backend.
export const LimpiarNumero = (valor) => String(valor ?? "").replace(/,/g, "");
